export { resizeImageClient } from './resizeImageClient';
export const IMAGE_CONSTRAINTS = {
  MAX_WIDTH: 4096,
  MIN_WIDTH: 640,
  ASPECT_RATIO_RANGE: [1.91, 4 / 5] as [number, number],
} as const;

export function getImageFullUrl(imageUrl: string): string {
  return import.meta.env.MODE === 'development'
    ? `https://pub-78f29ca659c643619854d230f6d4df70.r2.dev/${imageUrl}`
    : `https://cdn.face.golf/${imageUrl}`;
}
